var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app',{staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"notice"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.detail.title))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }